import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

export const fmt = (n) => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);

// Invoice number to display: normally `index`, but since the Qonto migration some invoices
// only carry their number in `reference` (and many carry none at all locally).
export const invoiceNumber = (inv) => inv.index || inv.reference || null;

// Tirana took over its own books on Jan 1, 2026 — money invoiced before that is not
// Tirana's responsibility, so its views default to post-cutoff invoices only.
export const TIRANA_CUTOFF = new Date("2026-01-01");
export const isTirana = (businessUnit) => businessUnit?.key === "TIRANA" || businessUnit?.name === "Tirana";

// Collection status colors follow severity: green = on track, blue = plan agreed / waiting,
// yellow -> orange = escalating reminders, red = legal action, purple = external recovery.
export const STATUS_COLORS = {
  "In progress": "bg-emerald-100 text-emerald-800",
  "Signed timetable": "bg-emerald-100 text-emerald-800",
  "Timetable sent": "bg-blue-100 text-blue-800",
  "Payment in progress": "bg-blue-100 text-blue-800",
  "Late payment": "bg-yellow-100 text-yellow-800",
  "Late payment in progress": "bg-yellow-100 text-yellow-800",
  "First reminder": "bg-yellow-100 text-yellow-800",
  "Second reminder + Call": "bg-amber-100 text-amber-800",
  "Third reminder": "bg-orange-100 text-orange-800",
  "Fourth reminder": "bg-orange-200 text-orange-900",
  "Mise en demeure to send": "bg-red-100 text-red-800",
  "Mise en demeure sent": "bg-red-100 text-red-800",
  "Mise en demeure received": "bg-red-200 text-red-900",
  "Injonction de payer to start": "bg-red-200 text-red-900",
  "Injonction de payer sent": "bg-red-300 text-red-900",
  "In recovery": "bg-purple-100 text-purple-800",
};

// Case-insensitive lookup — old records have lowercase statuses ("late payment in progress").
export const getStatusColor = (status) => {
  if (!status) return "bg-gray-100 text-gray-600";
  const key = Object.keys(STATUS_COLORS).find((k) => k.toLowerCase() === status.toLowerCase());
  return key ? STATUS_COLORS[key] : "bg-gray-100 text-gray-600";
};

export function ColorLegend() {
  return (
    <div className="flex items-center gap-3 text-[11px] text-gray-500">
      <span className="flex items-center gap-1"><span className="inline-block w-3 h-3 rounded-sm bg-emerald-100 border border-emerald-200" /> on track</span>
      <span className="flex items-center gap-1"><span className="inline-block w-3 h-3 rounded-sm bg-blue-100 border border-blue-200" /> plan agreed</span>
      <span className="flex items-center gap-1"><span className="inline-block w-3 h-3 rounded-sm bg-yellow-100 border border-yellow-200" /> reminders</span>
      <span className="flex items-center gap-1"><span className="inline-block w-3 h-3 rounded-sm bg-orange-100 border border-orange-200" /> escalated</span>
      <span className="flex items-center gap-1"><span className="inline-block w-3 h-3 rounded-sm bg-red-100 border border-red-200" /> legal</span>
    </div>
  );
}

const VIEWS = [
  { key: "", label: "Invoices" },
  { key: "recouvrement", label: "By client" },
  { key: "classic", label: "Classic" },
];

export function ViewTabs() {
  const navigate = useNavigate();
  const location = useLocation();
  const current = location.pathname.split("/cashout/")[1] || "";
  return (
    <div className="flex bg-gray-100 rounded-lg p-0.5">
      {VIEWS.map((v) => (
        <button
          key={v.key}
          onClick={() => navigate(`/cashout/${v.key}`)}
          className={`px-3 py-1.5 text-xs font-medium rounded-md transition-colors ${current === v.key ? "bg-white text-gray-900 shadow-sm" : "text-gray-500 hover:text-gray-700"}`}>
          {v.label}
        </button>
      ))}
    </div>
  );
}
